export default __webpack_public_path__ + "static/media/object--sign--information.88add084.png";